import { Injectable } from '@angular/core';
import { FailedVisionModel } from '../models/failed-vision.model';
import { IncidentServiceBase } from '../services/incident-base.service';

@Injectable()
export class FailedVisionIncidentService extends IncidentServiceBase<FailedVisionModel> {
    constructor() {
        super('FailedVision', () => new FailedVisionModel());
    }
}
